import { useState } from "react";

const useInventoryAccountSettings = (findAccountMapping) => {
  const [inventoryAccountMapping, setInventoryAccountMapping] = useState({
    inventory_asset_account:
      findAccountMapping("inventory_asset_account")?.chart_account?.id || "",
    cost_of_goods_sold_account:
      findAccountMapping("cost_of_goods_sold_account")?.chart_account?.id || "",
    stock_adjustment_lost_account:
      findAccountMapping("stock_adjustment_lost_account")?.chart_account?.id ||
      "",
  });

  return {
    inventoryAccountMapping,
    setInventoryAccountMapping,
  };
};

export default useInventoryAccountSettings;
